<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <entegratorsecim ref="entegratorsecim" @callStop="EntegratorAyarlariKayitEdilmedi"  @callDevam="EntegratorAyarlariKayitEdildi" @callEntegratorVar="EntegratorVar"></entegratorsecim>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ $t('Invoice-Received') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="gelenfaturaEkle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Invoice-Received')}) }}  </span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Invoice-Received')}) }}  </span>
              </v-tooltip>



              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select :label="$t('Date-Type')" items-value="value" item-text="text" :items="itemstarihtip"
                          v-model="tarihTip"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getListcontrol()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headersgelen" :rows-per-page-items="[20,100]" :items="itemssatis"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.PNR_No }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiTip  }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiKod}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.MasrafMerkezi }}</td>
                                    <td class="text-xs-left">{{ props.item.FatSeri }}</td>
                                    <td class="text-xs-left">{{ props.item.FatNo }}</td>
                                    <td class="text-xs-right">{{ props.item.KdvYuzde | moneyformat }}</td>
                                    <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                                    <td class="text-xs-right">{{ props.item.KDVliTutar | moneyformat }}</td>
                                    <td class="text-xs-right">{{ props.item.KDVTutar | moneyformat }}</td>
                                    <td class="text-xs-left">{{ props.item.TevkifatTutar | moneyformat }}</td>
                                    <td class="text-xs-left">{{ props.item.TevkifatOran | moneyformat }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaTarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaSeriNo }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisFaturaNo  }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisCariKod  }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisCariAd  }}</td>
                                    <td class="text-xs-left">{{ props.item.Isim  }}</td>
                                    <td class="text-xs-left">{{ props.item.EvrakNo  }}</td>
                                    
                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                   {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="GelenFaturaParams.PNR_No" hide-details>
                              </pnrbul>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select  :items="itemssaticitip" item-text="Aciklama" item-value="Kod"
                                v-model="GelenFaturaParams.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama :autofocuss="true" apiname="SaticiAra" :tip="GelenFaturaParams.SaticiTip"
                                :label="$t('Seller-Code')" v-model="GelenFaturaParams.SaticiKod"></genelarama>

                            </v-flex>
                            <v-flex pl-1 xs12 sm12 md12>
                              <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2')"
                                v-model="GelenFaturaParams.MasrafMerkezi"></genelarama>
                            </v-flex>
                            <v-flex pl-1 xs12 sm12 md12>
                              <geneltipara v-model="GelenFaturaParams.AcenteDepartmanID" tip="AcenteDepartman">
                              </geneltipara>
                            </v-flex>
                            <v-checkbox v-model="GelenFaturaParams.Proforma" label="Proforma" hide-details>
                            </v-checkbox>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../../api/auth";
  import tarihcomp from "../../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../../../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
  import entegratorsecim from "@/components/app/customcomp/entegratorsecim.vue";


  export default {
    data() {
      return {
        GelenFaturaParams: {
          GelenFaturaTarih1: null,
          GelenFaturaTarih2: null,
          SatisFaturaTarih1: null,
          SatisFaturaTarih2: null,
          GelenFaturaKayitTarih1: null,
          GelenFaturaKayitTarih2: null,
          SaticiTip: null,
          SaticiKod: null,
          PNR_No: null,
          MasrafMerkezi: null,
          AcenteDepartmanID: null,
          Proforma:false
        },


        GelenFatura: {
          KayitTipi: 1,
          Fatura: {
            SaticiTip: 1,
            SaticiKod: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
            FatPara: null,
            FatKur: 0,
            SatisPara: null,
            SatisKur: 0,
            VadeTarihi: null,
            HesaplananVade: null,
            FaturaTip: 0,
            MasrafMrkz: null,
            Proforma: false,
            Aciklama: null,
            MuhasebeFisTipi: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            TransferKod: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            Kalemler: [],

            ToplamTuta: 0,
            ToplamKDVliTutar: 0,
            ToplamKDVTutar: 0,
            ToplamTevkifatTutar: 0,
            ToplamStopajTutar: 0,
            FaturaNetTutar: 0,
            Satici: {
              id: null,
              kod: null,
              isim: null,
              tip: null,
              YurtIci_YurtDisi: 0,
              CariKod: null,
            }
          }
        },

        itemssaticitip: rez.SaticiTip,
        itemsicdis: rez.IcDis,
        itemsopsiyon: rez.Opsiyon,
        itemstarihtip: [{
          text: this.$t('Registration-Date'),
          value: 0
        }, {
          text: this.$t('Sales-Invoice-Date'),
          value: 1
        }, {
          text: this.$t('Invoice-Date'),
          value: 2
        }, ],

        itemskomisyon: [{
          text: this.$t('None'),
          value: false
        }, {
          text: this.$t('Available'),
          value: true
        }, {
          text: this.$t('All-v2'),
          value: null
        }],
        tarihTip: 0,

        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        // eslint-disable-next-line no-sparse-arrays
        headersgelen: [{
            text: "PNR",
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: "Satıcı Tip",
            value: "SaticiTip",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Seller'),
            value: "SaticiKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Date'),
            value: "Tarih",
            width: "10%",
            align: "left"
          },

          {
            text: this.$t('Expense-v2'),
            value: "MasrafMerkezi",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Serial'),
            value: "FatSeri",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('No'),
            value: "FatNo",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('VAT') + " %",
            value: "KdvYuzde",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Amount'),
            value: "PNR_Kar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Amount-with-VAT'),
            value: "KDVliTutar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('VAT-Amount'),
            value: "KDVTutar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Deduction-Amount'),
            value: "PNR_SatisTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Deduction-Rate'),
            value: "TevkifatOran",
            width: "10%",
            align: "left"
          },
          {
            text: "Satış Fatura Tarih",
            value: "SatisFaturaTarih",
            width: "10%",
            align: "left"
          }, ,
          {
            text: this.$t('Sales-Invoice-Serial'),
            value: "SatisFaturaSeriNo",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Sales-Invoice-No'),
            value: "SatisFaturaNo",
            width: "10%",
            align: "left"
          },

          {
            text: this.$t('Sales-Current-Code'),
            value: "SatisCariKod",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Sales-Current-Name'),
            value: "SatisCariAd",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Name'),
            value: "Isim",
            width: "10%",
            align: "left"
          },
          {
            text: "EvrakNo",
            value: "EvrakNo",
            width: "10%",
            align: "left"
          },

        ],

        Rapor: {
          PSirketNo: null, //eklendi
          PCariSirket: null, //eklendi
          PPNR_No: null, //eklendi
          PPNR_ParaBirimi: "TL", //eklendi
          PKayitTarihBas: null, //eklendi
          PKayitTarihBit: null, //eklendi
          PDonem1Bas: null, //eklendi
          PDonem1Bit: null, //eklendi
          PDonem2Bas: null, //eklendi
          PDonem2Bit: null, //eklendi
          PFatTarihBas: null, //eklendi
          PFatTarihBit: null, //eklendi
          PKomFatTarihBas: null, //eklendi
          PKomFatTarihBit: null, //eklendi
          PCariKod: null, //eklendi
          PSaticiTip: 1, //eklendi
          PSaticiKod: null, //eklendi
          PDosyaTip: null,
          PDosya: null,
          PAcente: null,
          PPNRBir: null,
          PCariHesapGrubu: null, //eklendi
          PCariTip: null,
          PSaticiGrup: null, //eklendi
          PSaticiIc_Dis: null, //eklendi
          PTurOp: null, //eklendi
          PFaturali: null,
          POpsiyon: null, //eklendi
          PAnaTip: null, //eklendi
          PCariAnaHesap: null, //eklendi
          PIptalRaporu: null,
          PRezGrupID: null,
          PSatisGrubu: null,
          PSatisGrupTip: null,
          PSaticiOdemesiHesapla: null,
          PMasrafMerkezi: null, //eklendi
          PAcenteDepartmanID: null,
          PPozisyonNo: null,
          PSatisFaturaNo: null,
          PMusteriOdemelilerHaric: null,
          PReferans: null, //eklendi
          PSatisTip1: null,
          PSatisTip2: null,
          PSatisTip3: null,
          PSatisTip4: null,
          PGelenFatTarihBas: null, //eklen
          PGelenFatTarihBit: null, //eklendi
          PProfilSablonId: null,
          PKomisyonFaturali: null,
          PGelenFaturali: null,
        },

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: "",
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: "",
        date2: null,
        menu2: false,
        dateFormatted2: "",
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",

        renk1: "info",
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],

        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize("en", this.dictionary);
      this.el = this.$refs.fab.$el;



      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      // if (this.sayfayetki.Status == true) {

      // } else {

      //   this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

      //     if (sonuc == true) {

      //       if (this.prevRoute != null) {
      //         var url = '#' + this.prevRoute

      //         window.open(url, '_self')
      //       } else {
      //         var url = '#/'
      //         window.open(url, '_self')
      //       }
      //     } else {

      //     }

      //   });

      // }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      geneltipara,
      entegratorsecim
    },
    watch: {},
    methods: {
      EntegratorAyarlariKayitEdildi() {
     
     this.$refs.entegratorsecim.close();

     this.getList();
   },
   EntegratorVar()
   {
    this.getList();
   },
   getListcontrol()
        {
           
            this.$refs.entegratorsecim.control();
        },
   EntegratorAyarlariKayitEdilmedi() {
     alert("Entegrator Ayarları Kayıt Edilmedi");
     this.$refs.entegratorsecim.close();
   },
      gelenfaturaEkle() {
        var url = '#/fatura/copergelenfatura/id?islem=yeni'
        window.open(url, '_self')

      },
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },
      git(val) {
        var saticiTip = SaticiTipConvert(val.SaticiTip)
        var url = "#/fatura/copergelenfatura/id?islem=get&st=" + saticiTip + '&sk=' + escape(val.SaticiKod.replace('&','%26')) + '&fs=' + val
          .FatSeri + '&fn=' + val.FatNo + '&ft=' + val.Tarih;
        window.open(url, "_target");
      },
      getList: getList,
      getListExcel: getListExcel,
      
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }

function SaticiTipConvert(text){
        var trMap = {
                '&':'%26',

            };
            for(var key in trMap) {
                text = text.toString().replace(new RegExp('['+key+']','g'), trMap[key]);
            }
            return  text;
  }
   

  function filtrele() {
    this.dialogfiltre = true;
  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;

    this.GelenFaturaParams.GelenFaturaTarih1 = null
    this.GelenFaturaParams.GelenFaturaTarih2 = null
    this.GelenFaturaParams.SatisFaturaTarih1 = null
    this.GelenFaturaParams.SatisFaturaTarih2 = null
    this.GelenFaturaParams.GelenFaturaKayitTarih1 = null
    this.GelenFaturaParams.GelenFaturaKayitTarih2 = null
    this.GelenFaturaParams.SaticiTip = null
    this.GelenFaturaParams.SaticiKod = null
    this.GelenFaturaParams.PNR_No = null
    this.GelenFaturaParams.MasrafMerkezi = null
    this.GelenFaturaParams.AcenteDepartmanID = null
    this.GelenFaturaParams.Proforma=false
    this.getList();

  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);



      if (this.tarihTip == 0) {

        this.GelenFaturaParams.GelenFaturaTarih1 = null
        this.GelenFaturaParams.GelenFaturaTarih2 = null
        this.GelenFaturaParams.SatisFaturaTarih1 = null
        this.GelenFaturaParams.SatisFaturaTarih2 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih1 = this.KayitTarihiBasla
        this.GelenFaturaParams.GelenFaturaKayitTarih2 = this.KayitTarihiBitis

      } else if (this.tarihTip == 1) {

        this.GelenFaturaParams.GelenFaturaTarih1 = null
        this.GelenFaturaParams.GelenFaturaTarih2 = null
        this.GelenFaturaParams.SatisFaturaTarih1 = this.KayitTarihiBasla
        this.GelenFaturaParams.SatisFaturaTarih2 = this.KayitTarihiBitis
        this.GelenFaturaParams.GelenFaturaKayitTarih1 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih2 = null



      } else if (this.tarihTip == 2) {

        this.GelenFaturaParams.GelenFaturaTarih1 = this.KayitTarihiBasla
        this.GelenFaturaParams.GelenFaturaTarih2 = this.KayitTarihiBitis
        this.GelenFaturaParams.SatisFaturaTarih1 = null
        this.GelenFaturaParams.SatisFaturaTarih2 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih1 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih2 = null

      }

      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;

        var RaporParam = {}


        RaporParam.GelenFaturaTarih1 = this.GelenFaturaParams.GelenFaturaTarih1
        RaporParam.GelenFaturaTarih2 = this.GelenFaturaParams.GelenFaturaTarih2
        RaporParam.SatisFaturaTarih1 = this.GelenFaturaParams.SatisFaturaTarih1
        RaporParam.SatisFaturaTarih2 = this.GelenFaturaParams.SatisFaturaTarih2
        RaporParam.GelenFaturaKayitTarih1 = this.GelenFaturaParams.GelenFaturaKayitTarih1
        RaporParam.GelenFaturaKayitTarih2 = this.GelenFaturaParams.GelenFaturaKayitTarih2
        RaporParam.SaticiTip = this.GelenFaturaParams.SaticiTip
        if (this.GelenFaturaParams.SaticiKod != null) {
          RaporParam.SaticiKod = this.GelenFaturaParams.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = null
        }


        if (this.GelenFaturaParams.MasrafMerkezi != null) {
          RaporParam.MasrafMerkezi = this.GelenFaturaParams.MasrafMerkezi.kod
        } else {
          RaporParam.MasrafMerkezi = null
        }

        if (this.GelenFaturaParams.AcenteDepartmanID != null) {
          RaporParam.AcenteDepartmanID = this.GelenFaturaParams.AcenteDepartmanID.kod
        } else {
          RaporParam.AcenteDepartmanID = null
        }


        RaporParam.PNR_No = this.GelenFaturaParams.PNR_No

        RaporParam.Proforma = this.GelenFaturaParams.Proforma


        var params = {
          Values: RaporParam
        }



        tool.http_post(this, 'GelenFaturaRaporu', params).then(

          response => {

            this.progress = false;
            this.load1 = true;

            if (response.body.Status == true) {
              this.itemssatis = response.body.data
            } else {

              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }

          },

          response => {

            this.text1 = 'Hata Oluştu, tekrar deneyiniz'

            this.snackbar = true
            this.progress = false;
            this.load1 = true;
          }

        );





      }
    }
  }

    function getListExcel() {
    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);



      if (this.tarihTip == 0) {

        this.GelenFaturaParams.GelenFaturaTarih1 = null
        this.GelenFaturaParams.GelenFaturaTarih2 = null
        this.GelenFaturaParams.SatisFaturaTarih1 = null
        this.GelenFaturaParams.SatisFaturaTarih2 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih1 = this.KayitTarihiBasla
        this.GelenFaturaParams.GelenFaturaKayitTarih2 = this.KayitTarihiBitis

      } else if (this.tarihTip == 1) {

        this.GelenFaturaParams.GelenFaturaTarih1 = null
        this.GelenFaturaParams.GelenFaturaTarih2 = null
        this.GelenFaturaParams.SatisFaturaTarih1 = this.KayitTarihiBasla
        this.GelenFaturaParams.SatisFaturaTarih2 = this.KayitTarihiBitis
        this.GelenFaturaParams.GelenFaturaKayitTarih1 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih2 = null



      } else if (this.tarihTip == 2) {

        this.GelenFaturaParams.GelenFaturaTarih1 = this.KayitTarihiBasla
        this.GelenFaturaParams.GelenFaturaTarih2 = this.KayitTarihiBitis
        this.GelenFaturaParams.SatisFaturaTarih1 = null
        this.GelenFaturaParams.SatisFaturaTarih2 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih1 = null
        this.GelenFaturaParams.GelenFaturaKayitTarih2 = null

      }

      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;

        var RaporParam = {}


        RaporParam.GelenFaturaTarih1 = this.GelenFaturaParams.GelenFaturaTarih1
        RaporParam.GelenFaturaTarih2 = this.GelenFaturaParams.GelenFaturaTarih2
        RaporParam.SatisFaturaTarih1 = this.GelenFaturaParams.SatisFaturaTarih1
        RaporParam.SatisFaturaTarih2 = this.GelenFaturaParams.SatisFaturaTarih2
        RaporParam.GelenFaturaKayitTarih1 = this.GelenFaturaParams.GelenFaturaKayitTarih1
        RaporParam.GelenFaturaKayitTarih2 = this.GelenFaturaParams.GelenFaturaKayitTarih2
        RaporParam.SaticiTip = this.GelenFaturaParams.SaticiTip
        if (this.GelenFaturaParams.SaticiKod != null) {
          RaporParam.SaticiKod = this.GelenFaturaParams.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = null
        }


        if (this.GelenFaturaParams.MasrafMerkezi != null) {
          RaporParam.MasrafMerkezi = this.GelenFaturaParams.MasrafMerkezi.kod
        } else {
          RaporParam.MasrafMerkezi = null
        }

        if (this.GelenFaturaParams.AcenteDepartmanID != null) {
          RaporParam.AcenteDepartmanID = this.GelenFaturaParams.AcenteDepartmanID.kod
        } else {
          RaporParam.AcenteDepartmanID = null
        }


        RaporParam.PNR_No = this.GelenFaturaParams.PNR_No

        RaporParam.Proforma = this.GelenFaturaParams.Proforma


        var params = {
          Values: RaporParam
        }


        tool.api_post_FileDownload(this, "Coper/ExcelGelenFaturaRaporu", params).then(
          response => {
            tool.CreateDownloadLink(response, 'CoperGelenFaturaRaporu.xlsx');
            this.progress = false;
            this.load1 = true;


          },
          response => {
             this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }



  function beforeMount() {}
</script>
<style>
</style>